import { cn } from "@newxsystems/shared";
import { resolveKaajPrimitive } from "../../../../client";

export interface KaajActionProps {
  ariaLabel?: string;
  className?: string;
  disabled?: boolean;
  href?: string;
  label?: string;
  rel?: string;
  target?: string;
  title?: string;
  variant?: string;
}

const variantClasses: Record<string, string> = {
  primary: "bg-[#2144FF] text-white shadow-[0_16px_32px_rgba(33,68,255,0.22)] hover:bg-[#132EDB]",
  secondary: "border border-[#D9E1FF] bg-white text-[#2144FF] hover:bg-[#F6F1FF]",
  outline: "border border-[#2144FF] bg-white/80 text-[#2144FF] hover:bg-white",
  ghost: "bg-[#F6F1FF] text-[#2144FF] hover:bg-[#EEE6FF]",
  link: "px-0 text-[#2144FF] underline-offset-4 hover:underline",
};

export const KaajAction = ({
  ariaLabel,
  className,
  disabled,
  href,
  label,
  rel,
  target,
  title,
  variant,
}: KaajActionProps) => {
  const Link = resolveKaajPrimitive("Link");
  const visualVariant = variant;
  const safeRel = target === "_blank" && rel === undefined ? "noopener noreferrer" : rel;

  if (!href || !label) {
    return null;
  }

  return (
    <Link
      aria-label={ariaLabel}
      className={cn(
        "inline-flex min-h-11 items-center justify-center rounded-full px-5 text-sm font-bold transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2144FF]",
        visualVariant ? variantClasses[visualVariant] : undefined,
        disabled && "pointer-events-none opacity-50",
        className,
      )}
      href={href}
      rel={safeRel}
      target={target}
      title={title}
    >
      {label}
      {visualVariant !== "link" ? (
        <span aria-hidden="true" className="ml-2">
          →
        </span>
      ) : null}
    </Link>
  );
};
